import { useToken } from '@/context/useToken';
import { Search } from 'lucide-react';
import LoginRequired from '@/components/common/LoginRequired';
import Page from '@/components/layout/Page';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { useUserFavouriteCoaches } from '@/data/userFavouriteCoach';
import Header from '@/components/layout/Header';
import FavouriteCoachesList from './components/FavouriteCoachesList';

const Favourites = () => {
  const userFavouriteCoaches = useUserFavouriteCoaches();

  if (userFavouriteCoaches.isLoading || !userFavouriteCoaches.data) {
    return null;
  }

  return (
    <Page>
      <Header title="Favourites" />
      {Object.keys(userFavouriteCoaches.data).length === 0 ? (
        <Empty>
          <EmptyIcon>
            <Search />
          </EmptyIcon>
          <EmptyTitle>No Favourite Coaches</EmptyTitle>
          <EmptyDescription>
            Click the heart icon on a coach&apos;s profile to add them to your
            favourites.
          </EmptyDescription>
        </Empty>
      ) : (
        <FavouriteCoachesList />
      )}
    </Page>
  );
};

const FavouritesLoader = () => {
  const { token } = useToken();

  if (!token) {
    return (
      <Page>
        <div className="flex justify-center items-center h-screen">
          <div className="text-center">
            <LoginRequired
              title="Favourites"
              message="You can add, view or edit your favourite coaches once you've
                  logged in."
            />
          </div>
        </div>
      </Page>
    );
  }

  return <Favourites />;
};

export default FavouritesLoader;
